import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import ButtonStyles from 'styles/theme/Button';

// icons
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';

const buttonStyles = makeStyles((theme) => ButtonStyles.getStyle(theme));
const useStyles = makeStyles({
    purchasingAgentActions: {
        display: 'flex',
        justifyContent: 'space-between',
        '& > div:nth-child(1)': {
            width: '85%',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
        },
        '& > div:nth-child(2)': {
            flexShrink: 0,
            width: '50px',
            '& > svg': {
                cursor: 'pointer',
                marginLeft: '5px',
                width: '20px',
                height: '20px',
                borderRadius: 2,
            },
        },
    },
});

const PurchasingElementActions = React.memo(({
    label,
    onOpen,
    onToggle,
}) => {
    const classes = { ...useStyles(), ...buttonStyles() };

    return (
        <div className={classes.purchasingAgentActions}>
            <div>{label}</div>
            <div>
                <EditOutlinedIcon
                    className={classes.containedInfo}
                    onClick={(e) => {
                        e.stopPropagation();
                        onOpen();
                    }}
                />
                <DeleteOutlineOutlinedIcon
                    className={classes.containedError}
                    onClick={(e) => {
                        e.stopPropagation();
                        onToggle();
                    }}
                />
            </div>
        </div>
    );
}, (prevProps, nextProps) => prevProps.itemId === nextProps.itemId);

PurchasingElementActions.propTypes = {
    label: PropTypes.string.isRequired,
    onOpen: PropTypes.func.isRequired,
    onToggle: PropTypes.func.isRequired,
};

export default PurchasingElementActions;
